import React, { Fragment, useEffect, useState } from 'react';
import { Switch, Route, Redirect, Link, NavLink } from "react-router-dom";

import $ from "jquery";
import 'slick-carousel'
// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";

import { passTypeMapper, categorySlugMapper, trimmString, categoryProxy } from '../helpers'

import SeoHead from '../includes/SeoHead'
import Loader from '../includes/Loader'
import Footer from '../includes/Footer'
import Navbar from '../includes/Navbar'
import QuestionsSection from '../includes/QuestionsSection'

import DataLayerHead  from '../includes/DataLayerHead'

import GetPassWidget from '../includes/GetPassWidget';


import Network from '../network';
const { loadDestination, getActiveDeals, getPassList } = Network

export default (props) => {

    const { destinationList, destinationID, match, history } = props
    const { lang } = match.params

    // console.log(destinationID)

    const [destination, setDestination] = useState(null)
    const [deals, setDeals] = useState([])
    const [passList, setPassList] = useState([])

    useEffect(() => {
        window.scrollTo(0, 0);
    })

    const LoadData = async (destinationID) => {
        try {

            const destination = await loadDestination(destinationID)
            const dealsList = await getActiveDeals(destinationID)
            const passList = await getPassList(destinationID)

            setDeals(dealsList)
            setPassList(passList)
            setDestination(destination)




        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        setFetching(true)
        LoadData(destinationID).then(() => {
            setFetching(false)
        }).catch(e => console.log(e))
    }, [destinationID])

    useEffect(() => {
        const target = $(history.location.hash)
        if (target.length) {
            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }, 100)
        }
    })

    const [fetching, setFetching] = useState(true)
    if (fetching) return <Loader />

    const Q_A = QuestionsSection(lang);

    const {hero_section} = destination.webData;
    const destinationTitle =  hero_section.textData ? hero_section.textData[lang].title:  '';
    const webTitle =  `IQM Pass - ${destinationTitle} - IQMpass.com`;
    return (<Fragment>

        <DataLayerHead webTitle={webTitle} />
        <SeoHead match={match} history={history} pageType="DestinationHomePage" />

        <Navbar lang={lang} {...props} />

        <HeroSection lang={lang} {...destination.webData.hero_section} {...props} />

        <AdvantagesSection lang={lang} {...destination.webData.advantages_section} {...props} />

        {/* <TeaserSection lang={lang} passList={passList} deals={deals} {...props} /> */}

        {/* <PricesAndVariantsSection lang={lang}  {...destination.webData.pricesVariants_section} {...props} /> */}

        <CategoriesSection lang={lang} deals={deals} {...props} />

        <VideoSection lang={lang} destination={destination} {...destination.webData.video_section} {...props} />

        <AboutSection lang={lang} {...destination.webData.about_section} {...props} />

        <Q_A lang={lang} {...props} /> 
        
        <DestinationsSection destinationList={destinationList} destinationID={destinationID} {...props} />

        <GetPassWidget match={match} />
        <Footer {...props} />

    </Fragment>)

}

/* DONE */
const HeroSection = ({ lang, textData, images, match }) => {

    const HeroSliderItems = images.map((img, index) => {
        return (
            <div key={index} className="heroSlider__item">
                <img src={`https://assets.iqmpass.com/${img.path}`} alt="" />
            </div>
        )
    })

    useEffect(() => {
        $('#heroSlider').slick({
            dots: false,
            infinite: true,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            fade: true,
            lazyLoad: "progressive"
        });
    }, [])

    return (
        <div className="section" id="hero">
            <div className="heroSlider__wrap">
                <div className="heroSlider__mask" />
                <div className="heroSlider" id="heroSlider">
                    {HeroSliderItems}
                </div>
            </div>
            <div className="container">
                <div className="hero">
                {
                        lang === 'hr' ?
                            <Fragment>
                                <h1 className="hero__title">{textData[lang].title}</h1>
                                <div class="hero__subtitle">Doživite više, uštedite više</div>
                                <Link className="hero__box" to={`${match.url}/deals`.replace("//", "/")}>Sve ponude i popusti</Link>
                            </Fragment> :
                            <Fragment>
                                <h1 className="hero__title">{textData[lang].title}</h1>
                                <div class="hero__subtitle">Experience more, save more</div>
                                <Link className="hero__box" to={`${match.url}/deals`.replace("//", "/")}>See all deals</Link>
                            </Fragment>
                    }
                    {/* <h1 className="hero__title hero__title--mb">{textData[lang].title}</h1><Link className="hero__box" to={`${match.url}/billing#couple`}>{lang === 'hr' ? "UZMITE SVOJU KARTICU" : "GET YOUR PASS"}</Link> */}
                </div>
            </div>
            <div className="hero__buttons">
                <div className="btn-circle btn-circle--active" />
                <div className="btn-circle" />
                <div className="btn-circle" /></div>
            <div className="spacer spacer--greenTop" /></div>


    );
}


/* TODO: advatages__list */
const AdvantagesSection = ({ lang, textData, match }) => {
    const { destinationWebUrl } = match.params
    return (
        <div className="section" id="advantages">
            <div className="container">
                <div className="advantages">
                    <div className="advantages__img">
                        <img src={`/img/backgrounds/cards/hand-${destinationWebUrl}.png`} alt="IQM Pass" />
                    </div>
                    <div className="advantages__box">
                        <h2 className="section__title section__title--white">{textData[lang].title}</h2>
                        <div className="section__text section__text--white">{textData[lang].description}</div>
                        <div className="advatages__list">

                            {lang === 'en' ?
                                <Fragment>
                                    <div className="advatages__col">
                                        <div className="advatages__item"> &nbsp; Excellent value for money</div>
                                        <div className="advatages__item"> &nbsp; Experience, feel the beauty and richness of the destination</div>
                                    </div>
                                    <div className="advatages__col">
                                        <div className="advatages__item"> &nbsp; Save money and time</div>
                                        <div className="advatages__item"> &nbsp; Discounts and benefits</div>
                                    </div>
                                </Fragment> :
                                <Fragment>
                                    <div className="advatages__col">
                                        <div className="advatages__item"> &nbsp; Izvrsna vrijednost za novac</div>
                                        <div className="advatages__item"> &nbsp; Doživite, osjetite ljepotu i bogatstvo destinacije</div>
                                    </div>
                                    <div className="advatages__col">
                                        <div className="advatages__item"> &nbsp; Ušteda u novcu i vremenu</div>
                                        <div className="advatages__item"> &nbsp; Popusti i pogodnosti </div>
                                    </div>
                                </Fragment>}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


// Todo
// Teaser field in pass
const TeaserSection = ({ passList, deals, match }) => {
    const { destinationWebUrl, lang } = match.params
    const teasers = []
    passList.forEach((pass) => {
        teasers.push(...pass.teasers.map(teaser => {
            return { passID: pass._id, ...teaser }
        }))
    })
    const teaser = teasers[Math.floor(Math.random() * teasers.length)]
    
    if(!teaser) return null;

    const pass = passList.find(pass => pass._id === teaser.passID )
    


    const url = `/${lang}/${destinationWebUrl}`

    let regularPrice =0;
    let yourPrice = 0;
    let youSave = 0;

    const SaveItems = teaser ? teaser.deals.map(dealID => {
        const teaserDeal = deals.find(deal => deal._id === dealID)
        
        if (teaserDeal) {

            const dealData = teaserDeal.dealData.find(data => data.lang === lang)
            const price = teaserDeal.price.find(price => {
                if (price.userType !== 'any') return false
                if ((price.currency === 'HRK' && lang === 'hr') || (price.currency === 'EUR' && lang === 'en')) return price
                else return false
            })

            const discount = teaserDeal.discount.find(discount => {
                if (discount.userType !== 'any') return false
                if ((discount.currency === 'HRK' && lang === 'hr') || (discount.currency === 'EUR' && lang === 'en')) return discount
                else return false
            })

            // console.log("teaserDeal", teaserDeal.categories)

            const isAccomodation = teaserDeal.categories.indexOf("to-sleep") > -1 ? true: false
            const duration = pass.duration/24
            const users = (pass.passType === 'TEAM' || pass.passType === 'FAMILY') ? 4 : (pass.passType === 'COUPLE') ? 2 : 1 

            // const multiplayFactor = isAccomodation?  duration: users
            const multiplayFactor = (price.priceConditions.find(cond => cond === "PERSON") ? users : 1) * (price.priceConditions.find(cond => cond === "PERIOD") ? duration : 1)

            const  save = multiplayFactor*(discount.discountType === "gift" ? price.value : (discount.discountType === "trade" ? price.value * ((100 - discount.value) / 100) : price.value - discount.value))
            
            regularPrice = regularPrice + multiplayFactor*price.value
            yourPrice = yourPrice + save
            
        }

        return (teaserDeal ?
            <div className="save__item">
                <CardSave pass={pass} teaserDeal={teaserDeal} match={match} />
            </div> : null)
    }): []

    youSave = regularPrice - yourPrice
    
    
    const users = (pass.passType === 'TEAM' || pass.passType === 'FAMILY') ? (lang==='hr'? "3-5 korisnika": "3-5 users") : (pass.passType === 'COUPLE') ? (lang==='hr'? "2 korisnika": "2 users") : (lang==='hr'? "1 korisnik": "1 user")
    const duration = lang === 'hr' ? (pass.duration > 24 ? `${pass.duration / 24} dana`: `1 dan`): (pass.duration > 24 ? `${pass.duration / 24} days`: `1 day`)
    return (
        <div className="section" id="save">
            <div className="container">
                <h2 className="section__title section__title--blue">{lang === 'en' ? "Example of your savings:" : "Primjer Vaše uštede:"}</h2>
                <div className="section__subtitle"> {`IQM Pass ${passTypeMapper(pass.passType, lang)} - ${users}  ${duration}`}</div>

                <div className="section__text">{lang === 'en' ? "Below we have listed some examples of the type of holiday savings you can achieve with your IQM Pass. The price examples below are approximate and do not represent exact prices available from all our deals." : "Dolje smo naveli nekoliko primjera vrste ušteda koju možete postići s IQM Pass-om. Primjeri cijena u nastavku su okvirni i ne predstavljaju točne cijene dostupne u svim našim ponudama."}</div>
                <div className="save">
                    <div className="save__list">
                        {SaveItems}
                    </div>

                    <div className="saveBar">
                        <div className="saveBar__item saveBar__item--yellow">
                            <div className="saveBar__text">{lang === 'hr' ? "Možeš uštedjeti" : "You can save"}</div>
                        </div>
                        <div className="saveBar__item saveBar__item--white">
                            <div className="saveBar__text saveBar__text--large saveBar__text--striked">{`${regularPrice.toFixed(2)} ${lang === 'hr' ? "HRK" : "EUR"}`}</div>
                            <div className="saveBar__text saveBar__text--small">{lang === 'hr' ? 'Regularna cijena' : 'Regular Price'}</div>
                        </div>
                        <div className="saveBar__item saveBar__item--white">
                            <div className="saveBar__text saveBar__text--large">{`${yourPrice.toFixed(2)} ${lang === 'hr' ? "HRK" : "EUR"}`}</div>
                            <div className="saveBar__text saveBar__text--small">{lang === 'hr' ? 'Vaša cijena' : ' Your price'}</div>
                        </div>
                        <div className="saveBar__item saveBar__item--blue">
                        <div className="saveBar__text saveBar__text--large">{`${youSave.toFixed(2)} ${lang === 'hr' ? "HRK" : "EUR"}`}</div>
                            <div className="saveBar__text saveBar__text--small">{lang === 'hr' ? 'Štedite' : 'You Save'}</div>
                        </div>
                        <div className="btn btn--green btn--fill btn--arrow">
                            <Link className="btn__text" to={`${url}/deals#to-sleep`} >{lang === 'hr' ? 'Uštedite sada' : 'Save now'}</Link>
                            <div className="btn__icon">
                                <svg viewBox="0 0 15.698 8.706" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.354 0l-.708.706 3.14 3.147H0v1h13.786L10.646 8l.708.706 4.344-4.353z" />
                                </svg>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
}



const PricesAndVariantsSection = ({textData, history, match }) => {
    const {lang, destinationWebUrl } = match.params
    const url = `/${lang}/${destinationWebUrl}`

    return (
        <div className="section" id="prices">
            <div className="container">
                <h2 className="section__title section__title--white">{textData[lang].title}</h2>
                <div className="section__text section__text--white">{textData[lang].description}</div>
                <div className="prices">


                    <Link className="prices__item" to={`${url}/billing#single`} >
                        <div className="bigBtn">
                            <div className="bigBtn__icon">
                                <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                    <g data-name="Layer 19">
                                        <path d="M32 32a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm0-30a14 14 0 1 0 14 14A14 14 0 0 0 32 2z"></path>
                                        <path d="M56 64H7a1 1 0 0 1-1-1v-7.5a25.5 25.5 0 0 1 51 0V63a1 1 0 0 1-1 1zM8 62h47v-6.5a23.5 23.5 0 0 0-47 0z"></path>
                                    </g>
                                </svg>
                            </div>
                            <div className="bigBtn__text">{lang === 'hr' ? "Jedna osoba" : "Single"}</div>
                        </div>
                    </Link>

                    <Link className="prices__item" to={`${url}/billing#couple`}>
                        <div className="bigBtn">
                            <div className="bigBtn__icon">
                                <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style={{ width: "54px" }}>
                                    <path d="M340.8 98.4c50.7 0 91.9 41.3 91.9 92.3 0 26.2-10.9 49.8-28.3 66.6L256 407.1 105 254.6c-15.8-16.6-25.6-39.1-25.6-63.9 0-51 41.1-92.3 91.9-92.3 38.2 0 70.9 23.4 84.8 56.8 13.7-33.3 46.5-56.8 84.7-56.8m0-15.4C307 83 276 98.8 256 124.8c-20-26-51-41.8-84.8-41.8C112.1 83 64 131.3 64 190.7c0 27.9 10.6 54.4 29.9 74.6L245.1 418l10.9 11 10.9-11 148.3-149.8c21-20.3 32.8-47.9 32.8-77.5C448 131.3 399.9 83 340.8 83z"></path>
                                </svg>
                            </div>
                            <div className="bigBtn__text">{lang === 'hr' ? "Dvije osobe" : "Couple"}</div>
                        </div>
                    </Link>



                    <Link className="prices__item" to={`${url}/billing#team`}>
                        <div className="bigBtn">
                            <div className="bigBtn__icon">
                                <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                    <g data-name="Layer 20">
                                        <path d="M22 31a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 22 5zM42 31v-2a12 12 0 0 0 0-24V3a14 14 0 0 1 0 28z"></path>
                                        <path d="M43 61H1a1 1 0 0 1-1-1v-9a22 22 0 0 1 44 0v9a1 1 0 0 1-1 1zM2 59h40v-8a20 20 0 0 0-40 0zM63 61H47v-2h15v-8a20 20 0 0 0-20-20v-2a22 22 0 0 1 22 22v9a1 1 0 0 1-1 1z"></path>
                                    </g>
                                </svg>
                            </div>
                            <div className="bigBtn__text">{lang === 'hr' ? "Tim" : "Team"}</div>
                        </div>
                    </Link>

                    <Link className="prices__item" to={`${url}/billing#family`}>
                        <div className="bigBtn">
                            <div className="bigBtn__icon">
                                <svg width={118} height={91} viewBox="0 0 118 91" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="#000" fillRule="nonzero">
                                        <path d="M117.653 79.668c0-6.646-2.35-12.295-7.048-16.992-3.099-3.1-6.647-5.199-10.596-6.248 1.55-.75 3.049-1.75 4.398-3.1 2.999-2.998 4.498-6.597 4.498-10.845s-1.499-7.847-4.498-10.846c-2.999-2.999-6.598-4.498-10.846-4.448v2.199c3.648-.05 6.747 1.25 9.296 3.849 2.55 2.549 3.849 5.598 3.849 9.246 0 3.648-1.299 6.748-3.849 9.296-2.549 2.498-5.547 3.799-9.046 3.848h-.25v2.15h.25c5.947.049 10.995 2.148 15.244 6.396 4.248 4.248 6.397 9.447 6.397 15.494v8.746H99.011v2.199h17.543c.749 0 1.1-.35 1.1-1.1v-9.844h-.001zM12.495 21.891c0 6.048 2.149 11.195 6.397 15.444 1.899 1.899 3.998 3.398 6.297 4.448-5.648 1.5-10.696 4.448-15.144 8.896C3.349 57.428 0 65.523 0 74.971v14.094c0 1.049.5 1.549 1.549 1.549h65.574c1.05 0 1.6-.5 1.6-1.549V74.971c0-9.447-3.349-17.543-10.046-24.291-4.448-4.448-9.497-7.397-15.144-8.896 2.249-1.05 4.348-2.549 6.297-4.448 4.249-4.249 6.397-9.396 6.397-15.444 0-6.047-2.149-11.195-6.397-15.494C45.582 2.149 40.384 0 34.336 0S23.14 2.149 18.892 6.397c-4.248 4.249-6.397 9.447-6.397 15.494zm3.099 0c0-5.148 1.849-9.596 5.498-13.245 3.648-3.648 8.097-5.498 13.245-5.498s9.596 1.85 13.245 5.498c3.649 3.648 5.498 8.097 5.498 13.245s-1.849 9.596-5.498 13.245c-3.599 3.599-7.897 5.448-12.945 5.498-5.448-.05-9.946-1.899-13.544-5.498-3.65-3.649-5.499-8.097-5.499-13.245zm40.833 30.988c6.098 6.098 9.147 13.445 9.147 22.092v12.494H3.099V74.971c0-8.646 3.049-15.994 9.146-22.092 6.047-6.048 13.295-9.097 21.792-9.146 8.896.049 16.343 3.098 22.39 9.146zM65.574 13.195v2.649c4.397 0 8.196 1.549 11.345 4.698 3.149 3.149 4.698 6.897 4.698 11.346 0 4.398-1.549 8.146-4.698 11.295-3.049 3.049-6.747 4.647-11.045 4.698h-.3v2.648h.3c7.247.051 13.444 2.699 18.592 7.848 5.198 5.197 7.797 11.494 7.848 18.842v10.695H72.271v2.699h21.341c.9-.049 1.35-.5 1.35-1.35V77.219c0-8.096-2.849-14.994-8.547-20.742-3.848-3.748-8.146-6.297-12.994-7.596 1.949-.9 3.748-2.15 5.397-3.799 3.648-3.649 5.448-8.047 5.498-13.195-.05-5.148-1.85-9.596-5.498-13.245-3.648-3.648-8.047-5.497-13.244-5.447z" />
                                    </g>
                                </svg>
                            </div>
                            <div className="bigBtn__text">{lang === 'hr' ? "Obitelj" : "Family"}</div>
                        </div>
                    </Link>


                    <Link className="prices__item" to={`${url}/billing#children`}>
                        <div className="bigBtn">
                            <div className="bigBtn__icon">
                                <svg data-name="Layer 1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M95 42.27A38.65 38.65 0 0 0 56.39 5H55v37.27H27.71v-4.83A14.7 14.7 0 0 0 13 22.79h-2.38a5.64 5.64 0 1 0 5 3.11 11.88 11.88 0 0 1 9.28 11.54v6.24a22.75 22.75 0 0 0 21.75 22.7l-7.28 7.28a12 12 0 1 0 2 2l9.25-9.25h13.8l9.25 9.25a12 12 0 1 0 2-2l-7.27-7.25h3.88A22.76 22.76 0 0 0 95 45v-1.33-1.4zM57.8 7.84A35.84 35.84 0 0 1 92.16 42.2H57.8zM10.63 31.23a2.81 2.81 0 0 1 0-5.62 2.81 2.81 0 0 1 0 5.62zM41.11 83a9.17 9.17 0 1 1-3.76-7.37l-4.66 4.66a2.78 2.78 0 0 0-.72-.1A2.81 2.81 0 1 0 34.78 83a2.78 2.78 0 0 0-.1-.72l4.66-4.66A9.08 9.08 0 0 1 41.11 83zM83 73.91a9.17 9.17 0 1 1-7.37 3.76l4.66 4.66a2.78 2.78 0 0 0-.1.72A2.81 2.81 0 1 0 83 80.23a2.78 2.78 0 0 0-.72.1l-4.66-4.66A9.08 9.08 0 0 1 83 73.91zM72.27 63.59H47.62a19.94 19.94 0 0 1-19.86-18.5h64.38a19.94 19.94 0 0 1-19.87 18.5z"></path>
                                </svg>
                            </div>
                            <div className="bigBtn__text">{lang === 'hr' ? "Djeca" : "Child"}</div>
                        </div>
                    </Link>

                </div>
            </div>
        </div>
    );
}


const CategoriesSection = ({ deals, match, history }) => {
    const {lang, destinationWebUrl } = match.params
    const url = `/${lang}/${destinationWebUrl}`

    const Categories = {}
    const categoriesSort = [
        "food-drink",
        "local-production",
        "excursions", 
        "sport-health",
        "entertainment",
        "to-sleep",
        "attractions",
        "transport"
    ]
    deals.forEach(deal => {
        const categoriesProxy = deal.categories.map(category => categoryProxy(category))
        const categoriesUnique = [...new Set(categoriesProxy)]
        categoriesUnique.forEach(category => Categories[category] = Categories[category] ? Categories[category] + 1 : 1)
    });

    const CategoriesItem = []
    for(var i = 0; i<categoriesSort.length; i++) {
        let cat = categoriesSort[i];
        if(Categories[cat])
        CategoriesItem.push(
            <div className="categories__item" onClick={() => history.push(`${url}/deals#${cat}`)}>
                <CardCategories category={cat} lang={lang} count={Categories[cat]} />
            </div>
        )
    }


    return (
        <div className="section" id="categories">
            <div className="container">
                {/* OLD: <Fragment>You can <span>save money</span> with all these discount attractions</Fragment> */}
                <h2 className="section__title section__title--blue">
                    {lang === 'en' ?
                        <Fragment>Experience more, save more!</Fragment> :
                        <Fragment>Doživite više, uštedite više!</Fragment>
                    }
                </h2>
                <div className="section__text">
                    {lang === 'en' ?
                        <Fragment>We take great effort to ensure the best service, quality of experience and level of savings you can achieve – simply presenty your IQM Pass each time you visit one of our listed deal providers.</Fragment> :
                        <Fragment> Ulažemo velike napore da osiguramo najbolju uslugu, kvalitetu iskustva i razinu uštede koju možete postići - jednostavno pokažite svoj IQM Pass svaki put kada posjetite nekog od naših partnera.</Fragment>}
                </div>
                <div className="categories">
                    {CategoriesItem}
                </div>
            </div>

            {/* <div className="spacer spacer--blueBot"></div> */}
            <div className="spacer spacer--grayTop"></div>
        </div>
    );
}

const VideoSection = ({ lang, textData, video, destination, destinationList }) => {



    if(!destination.videoURL) return null

    return (
        <div className="section" id="video">
            <div className="container">
                {/* <h2 className="section__title section__title--blue">{textData[lang].title}</h2>
                <div className="section__text">{textData[lang].description}</div> */}
                <div className="video">
                    {/* <video width="100%" height="auto" controls>
                        {video ? <source src={`https://assets.iqmpass.com/${video.path}`} type="video/mp4" /> : null}
                        Your browser does not support the video tag.
                    </video> */}
                    <iframe width="100%" title="video" height="auto" src={destination.videoURL} frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <div className="video__bg1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="424" height="424" viewBox="0 0 424 424">
                            <path className="cls-1" id="bg_effect" d="M1362 4220c0 116.9 95.1 212 212 212s212-95.1 212-212-95.1-212-212-212-212 95.1-212 212zm16.96 0c0-107.55 87.49-195.04 195.04-195.04s195.04 87.49 195.04 195.04-87.49 195.04-195.04 195.04-195.04-87.5-195.04-195.04z" transform="translate(-1362 -4008)"></path>
                        </svg>
                    </div>
                    <div className="video__bg2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="406.062" height="136.38" viewBox="0 0 406.062 136.38">
                            <path className="cls-1" id="bg_effect" d="M433.388 4494.95c-35.366 26.52-65.541 26.52-100.913 0-23.064-17.3-42.756-17.3-65.815 0-35.041 26.27-63.616 26.27-98.652 0-23.322-17.5-39.076-17.5-62.414 0l-9.622-12.84c28.357-21.25 52.182-22.12 81.663 0 27.792 20.85 48.306 23.32 79.4 0 29.481-22.12 56.892-21.12 85.065 0 28.921 21.7 51.611 22.55 81.663 0 29.5-22.12 48.781-22.12 78.262 0l-9.628 12.84c-23.697-17.79-35.29-17.79-59.009 0zm0-43.54c-35.366 26.53-65.541 26.53-100.913 0-23.064-17.31-42.756-17.31-65.815 0-35.041 26.27-63.616 26.27-98.652 0-23.322-17.5-39.076-17.5-62.414 0l-9.622-12.83c28.357-21.27 52.182-22.12 81.663 0 27.792 20.84 48.306 23.32 79.4 0 29.481-22.12 56.892-21.12 85.065 0 28.921 21.69 51.611 22.54 81.663 0 29.5-22.12 48.781-22.12 78.262 0l-9.628 12.83c-23.697-17.79-35.29-17.79-59.009 0zm-255.753 74.24c27.792 20.85 48.306 23.31 79.4 0 29.481-22.12 56.892-21.13 85.065 0 28.921 21.7 51.611 22.55 81.663 0 29.5-22.12 48.781-22.12 78.262 0l-9.628 12.83c-23.7-17.78-35.293-17.78-59.012 0-35.366 26.53-65.541 26.54-100.913 0-23.064-17.3-42.756-17.3-65.815 0-35.041 26.28-63.616 26.28-98.652 0-23.322-17.5-39.076-17.5-62.414 0l-9.622-12.83c28.36-21.26 52.185-22.12 81.666 0z" transform="translate(-95.969 -4422)"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
}

const AboutSection = ({ lang, textData, images }) => {
    return (
        <div className="section" id="about">
            <div className="container">
                <div className="about">
                    <div className="about__col">
                        <h2 className="section__title section__title--blue">{textData[lang].title}</h2>
                        <h3 className="section__subtitle">{textData[lang].subtitle}</h3>
                        <div className="section__text">{textData[lang].description}</div>
                        <div className="about__btn">
                            <div className="btnTextArrow">
                                {/* <div className="btnTextArrow__text">Read more</div>
                                <div className="btnTextArrow__icon">
                                    <svg viewBox="0 0 15.698 8.706" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.354 0l-.708.706 3.14 3.147H0v1h13.786L10.646 8l.708.706 4.344-4.353z"></path>
                                    </svg>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="about__col">
                        <div className="about__img1">
                            {images[0] ? <img src={`https://assets.iqmpass.com/${images[0].path}`} alt="Destination image" /> : null}
                            <div className="about__img2">
                                {images[1] ? <img src={`https://assets.iqmpass.com/${images[1].path}`} alt="Destination image" /> : null}
                            </div>
                            <div className="about__bg">
                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="360" height="360" viewBox="0 0 360 360">
                                    <image width="360" height="360" href="data:img/png;base64,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"></image>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="spacer spacer--grayBot"></div>
            <div className="spacer spacer--grayTop"></div>
        </div>
    );

}



const DestinationsSection = ({ destinationList, history, match, destinationID }) => {
    const { lang } = match.params
    const destinationItems = destinationList.map(destination => {
        if (destination._id === destinationID) return null
        const textData = destination.webData.about_section.textData[lang]

        return (
            <Link className="destinations__item" to={`/${lang}/${destination.webUrl}`} name={destination.name} title={destination.name}>
                <div className="card card--large">
                    <div className="card__img">
                        {destination.coverImage ? <img src={`https://assets.iqmpass.com/${destination.coverImage.path}`} alt="" /> : null}
                    </div>
                    <div className="card__row card__row--white">
                        <div className="card__h1">
                            <Link to={`/${lang}/${destination.webUrl}`}>
                                {destination.name}
                            </Link>
                        </div>
                        <div className="card__text">{trimmString(textData.description, 500)}</div>
                        <div className="card__btn">
                            <div className="btnTextArrow" >
                                <div className="btnTextArrow__text">Read more</div>
                                <div className="btnTextArrow__icon">
                                    <svg viewBox="0 0 15.698 8.706" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.354 0l-.708.706 3.14 3.147H0v1h13.786L10.646 8l.708.706 4.344-4.353z"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="destinations__mask"></div>
            </Link>
        )
    })

    return (
        <div className="section" id="destinations">
            <div className="container">
                <h2 className="section__title section__title--blue">
                    {lang === "en" ?
                        <Fragment>Other <span>IQM</span> destinations</Fragment> :
                        <Fragment>Ostale <span>IQM</span> destinacije</Fragment>}
                </h2>
                <div className="section__text">
                    {lang === 'en' ?
                        <Fragment>Each IQM Pass entitles you to a wide range of experiences and money-saving holiday options in a specific destination. Why not explore all destination deals available to you and expand your holiday experience to other destinations too?</Fragment> :
                        <Fragment>Svaki IQM Pass Vam daje pravo na širok spektar iskustava i mogućnosti odmora koji štede novac na određenoj destinaciji. Zašto ne istražiti ​​ponude svih destinacija koje su vam dostupne i proširiti vaše iskustvo odmora i na druga odredišta?</Fragment>
                    }
                </div>
                <div className="destinations">

                    {destinationItems}

                    <div className="destinations__bg">
                        <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="248" height="198" viewBox="0 0 248 198">
                            <image data-name="#bg_effect" width="248" height="198" href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPgAAADGCAYAAAD/oU3WAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH5AYaCgMYxDP/LAAALIlJREFUeNrtnXm4XdP5xz/3ZpBEIjfJJRE0BBFDiMQQQ8Q8q9BqUNX4lepAWxSl1YG22qpSMzWLFNWQiiEiRBoqxrRkIFGJkBAhIlIZ5N7fH9+z3eM4wx7Wu9c+N+fzPHm45+y9hn32u9a73vWu963rP+aHZIQOwInAPcCHvhtjTB/gOODPwCe+G2PMDsD+ub5+6rsxxuwMdAQm+25IQFvfDcjRHrgD+CpwDHAk8D/fjTJifeBmYF+gL/B9YLXvRhmxBfBXYGugK3AhrVfIdwEeRTJ1dO7/vdOmccQQ321oC9wGjMj93ReN+mOANb4b55gewGg0owEMBroD44Fm341zTF/g78B2ub+HAXXAE74bZsBg4AGgEU1WhwMvAv/13TDfAt4GuAk4oeDzfkB/YCytR8jbohf+wILPdwEagEm0ntntS8C9wI4Fnw8DlgLP+G6gQwYi4e6d91lH4AhgGvC6z8b5FPB64BrgWyW+3wbYDHiI6hfyNsDf0MhejF2BdYGJQJPvxiakN7Kj7FLi+4OBxcBzvhvqgG2Af6ABrZAO6Pf+NzDHVwN9CXg9cClwWoXrtgc2QSpstc5u9cAoZFsox25IhX2S6lXX1wfuBvascN2hwAKkxlYrWyINc4sy13QADgNmAq/6aKQPAa8Hfgv8OOT1A9GL8zDV9+LXAbfwxSVIKYYhbSUzVtgINCKD2r4hrz8CeAPNcNVGX2Qj2jbEtR2R1vIyMDvthqYt4HXARcB5Ee8bDHQBJlA9Ql4H/AU4KeJ9+wArgSm+OxCBHkhLOTDifUeiNerLvjsQgb5IS9kxwj0dgUOAl0jZ8JamgNcBP8/9i8NuSOWZmFaDE3IN8O2Y9+5P9RijGtAW56Ex7q1DM/l0pMZmnT7AXZS2L5QjMLy9RIqGt7QEvA44F/h1wnL2RCp+1teplwGnJyzjYOA9sm2Mqkez2eEJymgDfBmp6q/57lAZNkZbnLsnKKNDrq+pCXlaAv4j4PdI0JMyDBncniabFuffAGc7Kusw4C30QmSR0cBXHJTTjpbZzZvFuQw9kZayt4OyAsNbKmvyeusKgO8Bf3Rc10XAT9DonyV+BpzvuMwbgeN9d6wItwDHOiyvC3An4Y10abF+rq/7OSyzG7JZJNF8QmEt4KcCV2AjiBcBZxi3Pwrn5NpkQeDGmxWuB0YalNsdWeL38t3BHI3IrfgQg7K7IQ/O/ZMWVA5LAT8ZuBLbWfYPJF/ruuBM4HeG5dej2e0I3x0lmfEwDBsQbi/dmkakPVnOst2RU5CZkFsJ+PHA1WhtZUkdOqVk+cJV4jTgEtzYF8rRnuQGraRcBnw3hXp6oZl8kKd+1gM3oG08a7ohL8eoW4yhO+KaQ5Fa097woeRTB1yHjl+mzcnopU/DlgHaahmNjcpYid8iY2labIz82Xfw0NdbgaNSrK8Bbb8d7Lpg1y/mAehHWcf+mXyOOmS0GJG0oAicgLSUtI/cdkFr8mEp1vkzojsnuWAzpMKG8RhzxQ3ANzz0tRtahjnV0FwK+L7Ifa9jig+lsC93orO41oxA67O0tJRCeqARf7cU6jobO+NhGPqhpUm/FOq6AjjFY1+7I8Obs5nclYAPA+4HOqf/TD5HG7R2s1Rhj0E/QtpaSiG90Oy2k2EdZyD/Bd9sizTDrQ3ruJxsGGy7o4nKieHNhYDvjk7VdPH4UPJpj14Gl/uWAUeTDeEOCNapAw3KPg35L1gbD8MyAA1ofQ3KvgTITOwyJORODG9JBXwwmrm7+n4iBXRCwRVc7qceDNyOvyVIKfrk+jrYYZlpGw/Dsh0a0Lo7LPPXhD/ZmCYNaGlyUJJCkvyAO6CZe33fT6IEXdGL72Kduht62Ov67lQJ+qI1+XZJCwK+DlxFduL1FbIjOjrc4KCsn+b+ZZUGEu6axBXwYCTdyPcTqEAjEvI9EpSxE/AgsJ7vzlRgC7R22yJBGcegI65ZWYKUYhcUSSWJzecskh9+SoNgTX5YnJvjCHhg8EjyIqXJhmh2i3J+N2AQ8AjawqgGtkdrt01j3HsUsi9kbQlSiqHAfcTTqk5H6+5qoRvaGo1seIsq4FshVXUr3z2OSGCMiqLCDkbC3cN34yMyMNfXTSLcMxz5EVSLcAfsjzS0ThHu+QHwJ7JjPAxLN2RkPCDKTVEEfHM0E1o6HawwLDsI4xtmcBqA1HJL+8Iqw7IHI5+EMJrH4Wh2iCIkUbEMmnkQUmHDLCu+g3YGLO0LHxqWHQh5aMNbWAHvgxb7Aw0bPw0dMLCMm92PysuLfki4exq2YyJaR1oG4tsJRaRtKHPNPmjmtvRfuAmdo15qWMdw5F5azvFoJNrrtjwf8StgCDDPsI4G5OsRSsjDCPjGaISPE6YmLDOArwEvIBdQy1BF26F1ajEh74tiXEdRb6PyDDr6+W+07n3LsK4haBuz2Dp1RzTYWW5x3ov816cgTeFjw7qORcdY25X47ipsjYd/QsE+XkVW77cN6wrcWisa3ioJ+EZIuIcaNvY1FBUkiG6xAP0gliF1ByJbQr6Qb4a2/SxdIl9Ah3E+zP09E80+Cw3rHIbU9Q55n+2AUuu43E8u5AE0awZCPQVZ6S1TUo1Egpx/RPmraGfAcovzChSAJEhBNRM5qVgO3j2QX0ZZt9ZyAt4bqT17GzbydfQDzCr4fB46cvqKYd2DkHq6PhrIxuBmH7kU09CMvaTg8xfQ7LbIsO4D0dqtHtlQxqMtRCvGo9N9yws+fwRpaJa2lm8jJ502aPC8DdslyHVoy60wv9wMJHzzDesOttBKem3Wlcgu2hONDiZnVHPMQ66f5WbqbdGLuY1hO57K/TfJXnklXkYvW7mQuTshBw5LwXsQpYTa3LCOSSiw4LIy13wFDa4dwhQYk+BMQoNhHbegqEXlkkf2R7aQzQzb8SFa4k4o/KKYgPdAo16sjfWQLESz2dQQ1/YHxmH7UloyM9fXMAa1XdEs1+C70TH5F3pvloS49kR0NDPrTjWl+Cvwf4TTRrZEwtfHsD0fIK13fP6HhSp6PVI5LIX7fTTahBFukPp+JLbrGSvmoCVIWGv5VBSWaXnI67PE82jmDiPcIA3xe1Rn6uT70LHSsEuN2UibsHyHA3X9c9b1+oL/vw3b4H7LkHoWNWvHdCTk7xq2zTVvoCXIjIj3TUHPaKXvDkRgGpoUFke872bkVVZNeeceRNpH1EF4JlqTW1rXg/TUnyWhqM/7782Ez6EVh/+hF/fJmPe/iIQ87Azhk3m5vsZNyTMeBZWoBiF/Bb24cY2E16Nz51mMcV/IBLTDE3e7bzqya1kb3j5zaw0E/Hrgm4aVrqSEESAiU9GsaOk0kZS3c31NmqxgLPpNsqzCzkRbX0k1q6vQkc0sZ6uZjAbtpHv5M9AMO9ewrcF58sODHN0nG1b2KVr8P+iovEnIIr0sWTEmvItG+GcdlXc32tu1dGuNy2y0FTYraUE5LkN7yVnkWdy+c6+gmXyuYZsbgAPrsZ251yC1f4zjcichy/Qnhm2PyhI0kLnOCjqaylsxaTM311fXqX//gLzBssQ05Kfgemk4G9t98lHAWfXodIrVunYkmoUsmIhUpizMbh+jmftxo/JvJTvr1DdzfX3eqPyfYZtEIgozkPX7PaPyA7fWBY7LHY0MgavrURK/g9H2lUu+hUYRSx5Gxiifs9uKXBseNa7nGqTC+hTyt5BaHnaLMy7noYQWPpmFJr93jOsJDG+uttBGo7DPzdBiZHsWubu5quRMZJVPg/tRtg3LI4mlWI1U1YdSqKsZBSk4x0M/Qc5Jx6MJIQ1+hOLO+2A22rFxPbOWYjpu1PW/opn7s0kgfx/832jEeiNhJecgg0ma3AR8n3RntyY0Ut6Xcl8vJf0kBIuQLeWfKdd7GjookiavI/tO2rnKpyP5mxvz/lHoffzcRFfoyTYLOSzETU5+Pv5C4VyPZvK0hPwk7OwLlfgd8MuU6lqS66uVfaESp6J93TSYh7Y4p3vq66vIE+3NiPeNQsbyL2ixxU6TzUQL/6jbH7/Ev3HkBhSSx3o/9RTkaumTXyGrsyUfI+FOYwlSiuZcG+4xrmcBEm7LY8pheI1ohrc7KVDL8yl1XHQ2msnDboP8BqW3yYKjwtUo3Y4V30Vpi7LAucC1RmWvQLPCWN+dRDPTcYZtWYhctF35LyRlBjK8VXJrDazlJeWu3Hnw/6KDD5Wiq1wC/JxsbOEEXIqWC675ITqMkyVOx/06dTUSbtf+C0loQjPsw47LfTdX7r98d7CAYE1eyvAWCHdZuasU0WU+MjiU8h8PIllkSbgDLsZt3OsLcv3NGmtQMMGbHJXXhI5BWqvEcViFDElJXZ4DFqM9fdfOSa4IDqgUxngL1PKKO0dhYrK9g/Z5JxV8fh3yH86icAf8EuW1TsqFZDtIfhOKZOLC7+BUR+VY8T5S15Ma/T5Eg8Uk3x2qQKCuB0I+ipDCDdCmccSQMNctRyectkeBF25DWxhZ8CIrRzN6EbqgJIlxuBgNFFmwL1Tq61gU/SZuaOvT0G5E1vkERd/dlXgBMpejJcg43x0JyfvAY8hWcBYRJtWwAg6yqD6G9ukuJlt+4JV4FNgA2DnifX9ErpM+nGji0Iz25XckenKKM8nmEqQUHyF35ahCvgK5UGfJvhCGRehEW6SJJmpmk3eQldoy/K0VpxNtnRo4lFRTMAJy7T2GaK6zPyZ95yQXzEPq+nMhr1+N1PK/+W54WmQtPawlTcgYdWeIa69EW1DVJtwBKwm/Tj0fDWbVyjxkI6p0/r4Jzdz3+m5wmqxNAg4S2G+hFEaluAGtc6pFLS/FB0jIJ5e55hK03Kp23qCyB9opaGtprWJtE3DQ7PZ1ivuQ3472urN09joJi9DsVuyAyOVo66+1EAS4LOZmfRrpHX7KFGujgEOLCpvvNHE38lKzDMrvg2CbM99L62qU+L4aYr5FYRayP+Q7h5yJv1Np3imV+GBtYR0k5P9DL0Y17QxEZXN0tPY5NKNZphDyzeBcX6/FjR9E1WKZRrUaWIkc+9vQuoUbpLruletna9NSCnkB5Z9zHcSk6ljbBRxan5pajmoIOe2KtV64Ye1dg9eosVZQE/AaNVoxNQGvUaMVUxPwGjVaMTUBr1GjFVMT8Bo1WjE1Aa9RoxVTE/AaNVoxNQGvUaMVUxPwGjVaMTUBr1GjFVMT8Bo1WjE1AffHOr4bkCKdfTdgbSVLAr498BQ60tjaOQLF497Bd0NS4Ecot1mc8MbVxi9QGKw63w0JyMpx0W1R4IXewD9QNodKKZOqlQNRtsyuKHvIV4BXfDfKiFNQgsR2KHf1V1GEmdbIubRkfK1DkWq9k4UZfCs0wvfO/d0VeADYxXfDDNgXuCvXR4B+6MXv67thBoxE0Wnb5f7eAw1o6/pumAFn8PnMumehmPreJ1DfAr4pEuYvFXzeiELuDPTcPpcMQHHfuhV8vh2K0/2lyCVml2OBq/iinWEoCnbZwXcDHfJd4E9FPs+EkPsU8I2QOr5lie83ROGNt/bYRlf0R6mfGkt8PwjNbhv5bqgDjkLpj0rN1Aeg37Wj74Y6YCQayErxQxSW2tua3JeA90Yz9IAK1/VFI37UNDxZYkuUZWTDCtftitT33hVLzC6Ho/DE61W47lCkzbSrWGJ2OQ7F0K8kQz/Go+HNh4BvhEbwnUJevxXKRrGFh7YmZUuU6jasBXlPJOTVaHE+FGW+bAh5/RG569v4bngMjgFuIfwAdRaehDxtAe+FjEqhMx7m2A6psJum3N4kbA48AvSJeN9Q9OL39N2BCBySa3PXiPd9jepLSHA0Eu6ofgxnoR2FVIU8TQHvjraHhsa8f0ck5Jul2Oa4bIJS08a1ju+FnlU1OMPsh9JJd4t5/4ko13w1cDgS7rg7AT9GeeBSM7xFSR+chPXQC3twwnI2QimAHwGWpdHwGPQEHkRaRxI2RzaKvxMhH3TKbIsMpRskLGcnNAGM992hMuyHElfGHcgCdkOefRPSaHQaAt4FuBU40lF5m6DZ/BGUyD1LNKIXPqx9oRL9gW1QLuusCflWhDMehmVXpOJPIGIO7BQYioyC6zsqbzegE/CYdcOtBbwLysn9Vcflbob2yIO0Q1mgEc22ezgudxtkrBtLdoS8H9GMh2EZgvbIzV/8COyOflfXNpE9kKpv2ldLAe8M/AUlvrNgc+TL/RD+0w41IuPhPkblD0Dr+bH4n922RKr0pkbl75nr45Oe+wkacO7DzuC5OxJyM3XdSsA7IsPJ160anmMLtA4cjz8h74bsCwcZ17M9UofHeeonSHN6GA2uluyDNLOnkxaUgJ2RcLtagpQiEPInMNDQrAT8euTlkwb9cv/uJf3ZrTOyqn45pfoGo3WqD2NUb6QtpeVZuD/KpTbVQ1+3RdrSxinVtwdazk7EsZBbCPjlyD83TbZGs8p9KdbZEbgR7eWmyW5onToxxTp7ojMDA1Ossw5pRYtRyuO02BgNoGlvx5oY3lwL+CUo4boPtkdOJf9Ioa6OSEuxXoKUYk/kAfZECnX1REamVPZTC6hDTjQfAM+mUF9vNHBumbSgmATqujMhdyngFwPneHgo+QxEe+UPGNbREbga+Kbnvg7D3hjVE7nO+gzCUYfO0L8FTDOspzcydvk+3OTU8OZKwC8EfurxoeQzCFm1HzYouwM64/wt353MsQ/wKfBPg7I3QO6n+/nuJPK4PAR4A3jZoPwNkVqe1DnJFYGQTyShXcmFgJ+HBDxL7IJ7b6G2wGXAqb47V8DeKNm9y3VqAzIeHuK7c3m0AQ4DZub+uaIReR7u6LuDBQSGt0TW9aQC/kO07s4iuwPtgccdlff7XH+zRmCMWgi86KC8Lsh4eJTvjhWhLfKInAr810F5XZHNxod9IQyBW+ujcQtIIuDfofxh9ywwFFgDTE5YzoVIU8kq9ei45pskW6d2Rv4Lx/ruUBnaouOazwGvJ+zrGKQBZZlE1vW4An4KcA3+Qz6FYV9gBYrYGocLaAmml2XyhfzfMe5fDw3Y3/DdkRC0RcEq/wXMjXF/F+Rbbu2c5IrArTXykjOOgI9Eo7z3gHIR2B9YSvRIrecDv/bd+Ai0QUIe1eLcBfkvjPTdgQi0A4aj8NNvRbivKzreeoTvDkQk1hZaVAE/DvmXV8M55UIOABYBz4e8/hy09VdttEXHcucA00Nc3wkFDTzZd8Nj0AGtyR8jXDjmzijAxNG+Gx6TPdDvFdrwFkXFHo5iUFlGxJxkWHYb4Aq0vKjE6cioZkncJUMYOqBTfIeFuPYPwLcN2/IRtk4q6yO/h0rx/ToA1+L+ZGM+7yCLvCVno98slAYdVsAPQWe6LVPQXIHUS8stt3ZUXmeenGuLJT9FziM3GdaxLlpnlnNSuQj4vmEbVqNtxT1wt5tRjCBCb6l97OB3P8GwDUtz5R+OThZacgYho7WGUdEPRN5MDYYNvhbFrFqJZraOaM1hQbBOnc0XVdhvoiWIpfHwQiRYzejwxhZUnn3i0h4d152MjG/5/AL4uWE/1yCHoDuROnkv2tWIGqMuLA1oaTIJeLfgGVyBvZZyHC3bWUE4cEvHmd0JYV2vJOD7ozhoDYYNvQk4DY32oJfhCTQDWQl5W6S+vgrMyH12Atr/tQzl+0dkuAtoQsc/t0aBHSxohyzOTwBv5z47Hw0ylpyKnGUCViPvwr2wi//eDe2ajEf+6+ugGGjfM+znR8DxaLAOaEJhwfuiMxJWBGvyktb1cgK+N1Lxuhs28E60n76q4PMmpNJ1xy6FUTsk5M+jkfZ2bI2HV6O99E8LPl+D1pDbYxf/vQOyoUxEe8jWzkk/oHggxeVoht0Tu3PWjWgQGY8MpWcY9nM52nkodsCpOff5ZtgmmQyEvOjpwrr+Y4o6Z+2GbSQLkMp2EvBxmWvaof12SwvvciR0UUP+RuFGlGWzXAy5TmjUP8CwHUvQfrdlLPJzkRGoHJsiJxNL99D52MaXXwX8H5qkylGP7FfW/gWXAj+hYAIpNoMPwj6SxTi03q0UGbWJlvBAVqNge2x3Bm5Fwv1xhetWoyADu2EXDqkjtvaFCwi3tfghUiv3xW4SsRyw1yC1/7YQ1zajgXtL7GwtoOXsF85fFP7YW6CXzDJH1qPoHPVHIa9fhQwkYwzbZMUdyH89bIjnj5AV1nILzYpfEc0p6L9oy8rlwZE0aEI2oxsj3NOM4r/fY9y2M1GW08+s6/kCvjla91qGqZmEftSwwh2wAhnBLM95u+YutAUVta/L0bZkmlFMkvJb4rnzvoZsAq/57kAEStkXKrEGvcOVVPqknEOeD0cg4Jshc7vlmuUZ5EEUN2HBJ+gQxCPGD8gFY5AVOW5fl6GB8AXfHQnBlSSLBTAdaXRzfXckBGchY2lcVqOl6Sjjdp6NhLy+TeOIIRsjvd0yUuY0ZLF+P2E5q2k53pfVFEYPIcvq0oTlLEW/y34kzxxixXXISp00UOACNAEcTOXMpL64ADfejc1oGbw59lto7evRmrifYUUz0LpykaPylqGzyllcp05EOwNLHJX3BtJaZvnuWBFuRsK9OmlBOaYidd3Ve+KS3+L20FETmskt1fUmYHY9tg90FjqS93bSggpYigaNLK1TJ6M1luvnOR29+FkyRt2G/PVXOC73GeSU84HvDuZxCTbhyJqQ4e0ug7LXIC3ylnqkFj2UqLjivE5LsDwLPkQup9OMyo/C0yh8cpgTTXF4BQn5bN8dRbPO97BLGTWFeIZYCy7DNpBoIOR3Oy5zJNrBoR6NwkfjNtzwPLR2nG/4cEAxsw/CJhBfWF5Az+/dpAVVYDoaRFyEKorLPWjL0jof3BO5vvpMLnkt6YQAX42MjC7U9Wa0RPzMiBdY0VeiB+piJJmPXvh5KTwckErsaz91OjqPbC3cAdPQmtxKKyrHP5BHYVrJHscj76+VHvp6C3JOSos1aCa/I0EZwcx9e/6H+fvgK9FIEsY7pxTvoIHCRfC/KLyG1m5zUqxzDooK4tq+UInn0MmlxSnW+SiaGdLOyX4fOsjhypAXhjuR/8KqpAVFJBDQOFtoa9Dvc3vhF/UlLozipRPwHppJo4ZFcsVMdKAiSSC+sMxF6/83PPV1CprJXVnryzEJGQ99Gb7G5OpPI3Xy3Sjtlq9ElsGafHSEe0oKNxT3S25GThrXRKjkPaSW+966CizOlsuDN5Fh0rfBayLSliyNUVPQefL3PPf1Huwzyfwd2RfS1lIKieLWGljLS6r2pQ4eBP62l4WoZDF60aZ4fjABLyEV1sLA9zYy6r3qu5M5HkMCaGGMehYN2lnZlx6F3anC+9HJsCxY7qHFrbXcTP4Fg1oxKgV8mIBOWu1Z4vslaN2eZqbLMLyFlgqHoIihLliEjnJmaT8aWoIrHoW7SLf/QZ6HWRHugJfQrs/+Dst8CBnzsiLcAU3I461Y0IhmKszcAZUEvBnNEk0oD1Y+H+cqsQ4yF5e30BbWYSg6TBIW0xJsP4u8mvt3FMmPg85GA2PaxsOwTEUGsH0dlPUEMuKlYcuIQzG31rJr7kLChk2ejKzswci5IlfJ330/gQrMQxb9LxP/zPeHSA1OI1VvEmbk+jucEMH4SjAX2Rd8GQ/D0ISWg6tIlhjxKWSozJqWUkhwnnwrFHkotHBDtLjoU5B1cSe0jWAdOdIVb6D94+EouEMUlqKXwGUSQ0v+jWwPR8a4dz7yPPRtPAzLP9HLv0+Me59FdqMFvjsRgbFIJY800URNfPAUEmyLdLWWvI784r9M+KCKS5CxbrzvxkfkJfTiRsnc8TbSzqrpXDYoN3o7ouUvfx4ZD304CyWhiRhblXFSFyU9BumLWegFPpLKMcmCGNcWOcbT4EU0QIVJ//sOMh5m8cRaGCYRPgLvy+iQUlbtC85xkR+8mpiBfLmHU9oYVS5SZjUxFXmAlVunLs49i5d8NzYBzUijbETLx1IExsNqm7kTsbYJOGgUn4/U9UJj1AqU2sg6dlZaBI5Hexf5bgktSRGqnU/R2nR9YHCR7+cj46HPgzpeWBsFHGR0exsJecBq5MlkHU4nTZrRUdb2fN6X4SOqy3gYhtXIXrIJMDDv84XIOalalyCJWFsFHLROXYx8ypuRcN/qu1EGrEGzWyDky9DMXW3GwzA0IbtJkA7qHbQzECbLaqukmnJ8W3A12h9fgUIQtVbWAD/L/fclqiNwZVyChARLUVqsV3w3yCelMpvUqFGjFWCZ5aJGjRqeqQl4jRqtmJqA16jRiqkJeI0arZiagNeo0YqpCXiNGq2YmoDXqNGKqQl4jRqtmJqA16jRiqkJeI0arZiagNeo0YqpCXiNGq2YmoDXqNGKyZqA9/fdgJTogc4prw30AIb5bkRKrJfrb2bIkoD/BGUNCZMuqZpZF/gNCkxwuu/GGNMFnbN/BGV/bc10R4E1nkYxzDNBViK6nAFckvv/ISgU7uO+G2VAR+BiFFe+DkUzXUB1Bz0sRSeUpfYrKLDIoSiySlbyurmkAcUtH0KLxvIwSprhlSzM4N8F/lTw2U/RjN7a+A3wg7y/26KoMl/33TDHrJPr17F5n3VGubdbm7reGfgbMDTvswEo68+XfDfOt4B/E70IxbgY+JHn9rnkp0hTKWQd4C98XhiqmbbA5Sj0dCGdUTjqTKiNDugI3EXxZIiDgPuATX020KeAH49UuHJ5tP5E61inng38usz3HVHAx2qfydui3+w7Za5ZD63Jd/bd2ISsg1IJHVbmmkHAGJQh1Au+BPxryPhSKehjHZoNvu+pnS44E/hDiOvWAW5AGUKrkXa5foYZkLsiIR/ku9Ex6YDe3zCGwx2RkPfz0VAfAn40cAt6ocO28XLgVA9tTcrpwKURru8E3IYMUtVEG6ShnBHhnu4oN/e2vhsfkXWAa5AGGpYd0Jp8y7Qbm7aAH4qEu1PE+4J1XTWtU78NXBHjvi7IGOUyyb0ldcAvgXNi3NsT5ZfPzLZSBdqh9/CkGPduB9xNyoa3NAV8X5TXeL2Y93dAxqjhKbY5LieiUT4uDSh90k4JykiLn6OY63HpA4xDyQqyTBu0lfudBGXsiAxvfdJqdFoCPhSlHU7q5dMZDRJRUuOmzQg0EFXKYFqJbij7SJaNUWeg2TspW6Ak95v57lAJ6oDfAi6SCASGt1T6moaA7472CTdwVF4XYDTZXKcejazh7R2V1x05TOzou2NF+D5f9F9IwrakPLuFpB64iHhLkFIEW2ibp9F4S4Yg40JPx+V2RkJ+pHH7o3AkMpB1cFxuD2SM2sZ3B/P4NnCVQbk7oMlgI98dzFEPXIB8GCz6eh/G1nVLAR+M1pG9jMrvirYqsmCMOiTXls5G5fdCQm4+4ofgJOB6w/J3Rss5VxpfEs7DzRKkFAPQgLapVQVWAj4ACfcmVg3P0R2l+93VuJ5y7It2Brob1xMYo3y6PwbOSdYMRR5iG3rs6zmUd05yxfZIyzVZmlgI+CZI9UjLe6cnMtD4UGH3RN5MrpcgpeiPhNzHOjWwL6RlmN0nV5+P45enAb9PsT4zw5vrH2sj4DHSVyV7odNnW6dY527IDtA75b4OQCeX0nR/PBztzbdLua8HIu2oW4p1ngRcmXI/wcit1aWA9wYm4MklD82iE0gnaMQuSIW0XoKUYgfkNJHG4HIwWhO7Nh6G5QiU57trCnWdkKvLFwNx7NbqSsB7ou2cNGfQYmyEfJwtXQIH4cEjqQg7oUFmfcM69kNaipXxMCxHIT/9dQ3rGIF2QeqSFpSQHYB7ceT440LAe6B14fYeH0o+fdCRRIvZbQCazTb13ckcQ5GRscGo7NGkqx6X42vAddgMNkcjW4rv49MBA3A0iSTt0HrIwJU1l8r+yMfZpfGrH3rovpYgpTgQefe5VGF3JTtbVfmcQOn4AXHxZV+oRLAmT2RQTSLgXXIN2NP3kyjBQOAB3Aj5+kht8r0EKcURyOLc6KCsQWiLMyvOJoWcCFzrqKwD0KDty75QicEktK7HFfAuaP23n+8nUIGd0QNKIuSNwKNIbcoyw5EPfJL9+GD959u+UInvEO+kXj57IyeTqCcb0yaRdT2OgAcHPrLoC16M3dEoHcdpIvAFH+i7EyEZjlxI47y025HiIQgHnE64QBrF2BMNZGlY5l0wEPmWRDYeR42q2hG5ZH7Vd48jsimanR4AVoS8p1vu+mqLHzaAlt2ENSHv6Y+EO/WABAnZA01SkyLc4/rwU1r0BPZCv+uHYW+KIuDtkRXzBN89jUlfFFhgHLC6wrVdkCV+aKVCM8pA9EI8AjRVuHZzJNxZOswShWHAp8A/Q1y7M9k6zBKVXuidHA8sDXNDWBW9LVrzjDRs/FKkds03rOMopIGU20/thNS3vQzb8TYKF73csI5TgD9XuOZLyA96O8N2PA382LB8kM94pTDbA7E/HzEORQquNIEkIZLhLcwM3g6d+/2eYaOXIc1gFDAVbV1YOVdsi1T2R4FVBd91QsZDS/vCYnT6bBwwC62bKwWfjMvOaI98fJHvuqETapZnzf+DAhM+gn7jgwzr2h+prlOLfLcdGsgs3XufQML9NPpdj8ZuX31DpLlMAJaUu7CSgAeRMl1EsijFx7kHMzb393zgBRSO1srCGaxTH6NFyDsh4+Fww74uQfvWQSaTmcDruTqtXoYhub49lvdZAxJ6S/+FWeg3fDP397/Qs7bceTkIWAQ8n/dZf2IaqCIwGTgOeDf39wzshbwXEvKJwAelLion4PUoE4elevUJUiX/VvD5XOBlNJNb7VEOREI+PtfXG5G7ohUfIm+spwo+fwVYiG0Yqj2QC+YkZF94EB2WsWIu0lLeKPh8CtJWrJY/dUjI3wKm0RIKyvJ8wlT0uy4s+Hw6LRpa0vBdpeiFtvtKzuTlBPxC4HzDB7Maqf13lPh+DjAbCbmrEEiFDESz2UHAtwz7ugwlNRhf4vsX0eh/uGEb9kbGqB8gBw8r3kEHVErlIJuMfk8rB6l6pCW9j+KoWbpQv4R2lN4q8f109A4Px24m74me5SMUMbzV9R9TVPv+OfArwwezBp25vS7Etccjw1jYOOpZYzkS7rEhrj0NP0cVXbEYDR7TKlzXFqWmsja+WTIdCe6cENcei5Z/lu6wL6LB5nNaU7EZ/FykmlvRjGaRsO6GL6NR8EjsVB0rPkHGw/tDXv8sGoUP9t3wGHyANKEwmVKb0Pn9HujobbXxKhLu2SGvfwWp60dha3jbiwJ1vVDAT8NtpMxinEH0WWo6Wtd92fABueZ/aFvx7xHvewY542Qh1lxYlqBB6fkI9zQjy/MGaOunWpiD3sPXIt43Aw0MaVjXHyXnDJMv4KeSLFh/GM4jWiqffP6D1ndZjokesBIZD++Kef9TaJtwd98dCcEyZFCbGuPeT9HLuCHVkadsPtoZmBXz/sDwZjmTB4a3x4APAgEfiX0wvYty/5LwAhqZsqzCfopiht+WsJynkENOll1lP0Y2kscTlLEGvYx9yE5MgWIsQv4RryQsZzotKr6ldX0Y8HibxhFDjsU+ksWlaPZ2wVT0Uuxr2N64NANn4eY442q0rdUVv1FjS/EJil92v6O+BuG2sngk9yO0wxFlCVKONJacvYCGNo0jhryErfHqzyiFrksmI0PNPobtjsM5wGUOywtmtx5kK4XRSiTc9zgscxXyrNuBbAXV+Bip5U8lLaiA/2C7hTYDOLVN44ghK7DbF70aWcwtmJx7MMOMyo/KecQ/vliOJjS79SIbxqhVyGfgr0Zlj0MaSxaOrS5HNp/JRuW/gox2R+NWg56BjLTz2zSOGPI08B4apVxyIzpQYckktE7dw7ieSvwS263FQMj7oBnOF6uQMfaOpAWVYSWayXfHb+CJFWhrNol9IQwvIyEfjhshn4UcfRZAixX9udwHhzuq5B4UWicNJuFXhf0DydLnhuVT9LL1w886dQ3SxtLIbPI/NJPvjZ+jnauQpfvRlOrLF/Ik6vocJNyfncjML+wvyJr+acLGjgFOTunBgAw0Z5HOi1fIlcgxKC2WosR/96fcz2bkdRbG89AV76EZdFrKfQ2WIA+nXO9oJH9hg3QU8hpSy+flf1g4WtyO3CpXxqxkLPB/aG80TVYgIR+VYp03YGdfKMf76PTdgynW+RPgcg99XYibramwrEZLkDTfo3xGEU/IZ1JEuKG4OnAP8A3ChzYKGIcsq6EiTRjwEQrGl3T/OQw3oRfBFx+h44kTUqjrZ9gYD8OyEKmdcZ1LwrIG2Yxu9dhXkJCfSOVIPAGfGdSKfVlK3/8bcpAPK6wP5xq1JOT1VixHP9JowzruIN0lSCmWoeOtUwzruBBb42FYFlL8+KkrmtDJRp9pi/IZjeSpucJ1M9AO2IJSF5Rb0I9FL9AHlOdxNOP7Fu6AT9BMPsag7HuRepwVlqCIKWEOeETlEuAXvjuYx1wKDEiOaAZ+hJZcWeJOJOSl1PXX0KC3oFwhlSx244Fj0DHAYkxBp6Xe9/00CliGZtlxDssch4wvlUbVtFmErK8u16lXIaedrDEHDWjvOCzzXLJ7RHcUmlAKDd+z0cm9NysVEMYk/ziyZr5d8PlU5Ie8MEQZPliCbAITHZT1MHrQH/nuVAneRMaoGQ7KuhEFv8wqz6H30cV7dwHSVLLMnWhiCWbymSjs1dwwN4fdc3saHSYP1KMXkfpuGQHVBYvR8uHJBGWMz5VRaanim/loVI96jDGf2/BrPAzLs8j7K4mQX4iisVYDt6PdqX+iNXdouYuyqf4MetHHIOGeF+FenyxEat3TMe59nGwuQUrxFnoB/hvj3jvRSxTWeuubZ9Bv816Me39HtuwLYbgdBXR4O8pNUb1mnkTCEiZMTZZ4n+jGqCfQVtTiCPdkgTfRTB5FuwqMh9Ui3AGPo2VYlAH4j7g72Zh5qiU6igveQWu3MOvUp5F9YZHvRsdkDor0GWZ2G4cGsrgeVL55EFmbw2zpXg2c7bvBabI2CThoVjuC8rG0nkcvvEtLrQ+eQb4M5TSQCciAk9Q92TcPIQ2kXKaYm8m28dCEtU3AQevTwyjuNDENzXwVtx+qhMfRoYlFJb4bSfVqKYWMRTP5J0W+G4V8+LO2xWnO2ijg0LKPmG8onI7W6VbeUr6YwhfV9clIGBbEKjG7jEGGwvyUVHejdXq1LkESsbYKOLQI+SK0p3gU8azP1cCT6BDRcrTFdAIRrbFVxF20qOJj0c5PtS9BYmOV9K5aeBUFSFxD+BjX1coEFDprDtn3X0jKLUAjEnbLTJ+Z5/8Bhxz3MANSwd4AAAAASUVORK5CYII="></image>
                        </svg>
                    </div>

                </div>
            </div>
            <div className="spacer spacer--grayBot"></div>
        </div>
    );

}





/* Includes */


const CardSave = ({ pass, teaserDeal, match }) => {
    const { lang, destinationWebUrl } = match.params

    const dealData = teaserDeal.dealData.find(data => data.lang === lang)
    const price = teaserDeal.price.find(price => {
        if (price.userType !== 'any') return false
        if ((price.currency === 'HRK' && lang === 'hr') || (price.currency === 'EUR' && lang === 'en')) return price
        else return false
    })
    const discount = teaserDeal.discount.find(discount => {
        if (discount.userType !== 'any') return false
        if ((discount.currency === 'HRK' && lang === 'hr') || (discount.currency === 'EUR' && lang === 'en')) return discount
        else return false
    })

    const curencyMap = {
        "HRK": "kn",
        "EUR": "€"
    }
    



    const url = `/${lang}/${destinationWebUrl}/deal/${teaserDeal._id}`


    const isAccomodation = teaserDeal.categories.indexOf("to-sleep") > -1 ? true: false
    

    const duration = pass.duration/24
    const users = (pass.passType === 'TEAM' || pass.passType === 'FAMILY') ? 5 : (pass.passType === 'COUPLE') ? 2 : 1 
    
    
    
    let totalPriceText = `${price.priceType === "FULL" ? (lang=== 'hr' ?  "Puna cijena  ": "Full price " ): (lang=== 'hr' ?  "Prosječna potrošnja ": "Average spend " ) }`
    
    const getStayCondition = (days, lang ) => {
        if(lang === 'hr')
            return days>1? `za ${days} dana boravka ` : `za ${days} dan boravka `
        else
            return days>1? `for ${days}-day stay ` : `for ${days}-day stay `
    }

    const getPeopleCondition = (people, lang ) => {

        const personsHR = ["za jednu osobu", "za dvije osobe", "za tri osobe", "za četiri osobe", "za pet osoba"]
        const personsEN = ["for one person", "for two people", "for three people", "for four people", "for five people"]

        if(lang === 'hr') 
            return personsHR[people-1]
        else
        return personsEN[people-1]
    }

    if(price.priceConditions.find(cond => cond === "PERIOD"))
        totalPriceText = totalPriceText + getStayCondition(duration, lang)

    if(price.priceConditions.find(cond => cond === "PERSON"))
        totalPriceText = totalPriceText + getPeopleCondition(users, lang)    

    const multiplayFactor = (price.priceConditions.find(cond => cond === "PERSON") ? users : 1) * (price.priceConditions.find(cond => cond === "PERIOD") ? duration : 1)

    const  save = multiplayFactor*(discount.discountType === "gift" ? price.value : (discount.discountType === "trade" ? price.value * ((100 - discount.value) / 100) : price.value - discount.value))
    const totalPrice = multiplayFactor*price.value;


    const discountType = discount.discountType === 'cash' ? `-${multiplayFactor*discount.value}${curencyMap[discount.currency]}` :
        (discount.discountType === 'trade' ? `-${discount.value}%` : "GIFT")


    // console.log("teaserDeal", price.priceConditions, price.priceType, totalPriceText)
    // console.log("teaserDeal", teaserDeal)
    
    return (
        <div className="save__item">
            <div className="card">
                <Link to={`${url}`} name={dealData.title} title={dealData.title}>
                    <div className="card__img">
                        <h3 className="card__title">{dealData.title}
                            <div className="card__icon">
                                <svg viewBox="0 0 15.698 8.706" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.354 0l-.708.706 3.14 3.147H0v1h13.786L10.646 8l.708.706 4.344-4.353z" />
                                </svg>
                            </div>
                        </h3>
                        <div className="card__discount">{discountType}</div>
                        <div className="card__img-mask2" />
                        <div className="card__img-mask" />
                        {teaserDeal.coverImage ? <img src={`https://assets.iqmpass.com/${teaserDeal.coverImage.path}`} alt="" /> : null}
                    </div>
                </Link>
                <div className="card__row card__row--white card__row--col2">
                    {/* <div className="card__text">{` IQM Pass ${pass.passType} ${duration}`}</div> */}
                    {/* <div className="card__text">{price.description ? `${price.description[0].toUpperCase()+price.description.slice(1)}  ${price.value} ${price.currency}`: ""}</div>
                    <div className="card__text card__text--striked"> <b>{lang=== "hr" ? "Ukupno": "Total"}</b> <br /><span>{`${totalPrice} ${price.currency}`}</span> */}


                    {/* <div className="card__text">
                        {price.description ? `${price.description[0].toUpperCase()+price.description.slice(1)}`: ""}
                        <br/> 
                        {totalPriceText}
                    </div> */}
                    <div className="card__text-wrap">
                        <div className="card__text">
                            {price.description ? `${price.description[0].toUpperCase()+price.description.slice(1)}`: ""}
                        </div>
                        <div className="card__text card__text--striked">
                            <b>{`${price.value} ${price.currency}`}</b>
                        </div>
                    </div>

                    
                    <div className="card__text-wrap">
                        <div className="card__text">
                            {totalPriceText}
                        </div>
                        <div className="card__text card__text--striked">
                            <span>{`${totalPrice} ${price.currency}`}</span>
                        </div>
                    </div>
                </div>
                <div className="card__row card__row--green card__row--col2">
                    <div className="card__text">{lang === 'hr' ? "Cijena sa IQM pass-om" : "Price with IQM pass"}</div>
                    <div className="card__text"> <span>{`${save.toFixed(2)} ${price.currency}`}</span>
                    </div>
                </div>
            </div>
        </div>

    );
}


const CardCategories = ({ category, count, lang }) => {
    return (
        <div className="card">
            {/* Handle link to other categories */}
            <Link to="" name={category} title={category}>
                <div className="card__img">
                    <h3 className="card__title"> {categorySlugMapper(category, lang)}
                        <div className="card__icon">
                            <svg viewBox="0 0 15.698 8.706" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.354 0l-.708.706 3.14 3.147H0v1h13.786L10.646 8l.708.706 4.344-4.353z" />
                            </svg>
                        </div>
                    </h3>
                    <div className="card__count">{count}</div>
                    <div className="card__img-mask2" />
                    <div className="card__img-mask" />
                    {/* Handle change image on different categories */}
                    <img srcSet={`/img/cards/categories/${category}@1x.jpg 1x, /img/cards/categories/${category}@2x.jpg 2x`} src={`/img/cards/categories/${category}@1x.jpg`} alt={category} />

                    {/* <img src={`/img/categories/${category}.png`} alt="" /> */}

                </div>
            </Link>
        </div>

    );
}